<template lang="pug">
div fundraisers
</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import CustomizeCustomerColumn from '@/components/connect/CustomizeCustomerColumn.vue'
import FilterCustomerDrawer from '@/components/donation/FilterCustomerDrawer.vue'
import DeleteCustomerDialog from '@/components/connect/dialogs/DeleteCustomerDialog.vue'
import AddSegmentDialog from '@/components/connect/dialogs/AddSegmentDialog.vue'

export default {
  name: 'Campaign',
  props: {
    isSelectionMode: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: 'Confirm'
    },
    loading: {
      type: Boolean,
      default: false
    },
    previousCustomers: {
      type: Array,
      default: null
    }
  },
  components: {
    CustomizeCustomerColumn,
    FilterCustomerDrawer,
    DeleteCustomerDialog,
    AddSegmentDialog
  },
  data: () => ({
    isLoading: false,
    searchText: '',
    currentPage: 1,
    pageSize: 20,
    totalCount: 0,
    customers: [],
    selectedCustomers: [],
    showFilterDrawer: false,
    isDeleting: false,
    options: [
      {
        text: 'Phone number',
        value: 'phone',
        enable: true
      },
      {
        text: 'Created on',
        value: 'created',
        enable: true
      },
      {
        text: 'Email',
        value: 'email',
        enable: true
      },
      {
        text: 'Gender',
        value: 'gender',
        enable: true
      },
      {
        text: 'Age',
        value: 'age',
        enable: true
      },
      {
        text: 'Nickname',
        value: 'nickname',
        enable: false
      }
    ],
    checkAll: false,
    showDeleteDialog: false,
    showAddDialog: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      filters: 'customers/getFilters'
    }),
    headers: {
      get() {
        const filteredOptions = this.options.filter(item => item.enable)
        const checkbox = {
          text: '',
          value: 'checked'
        }
        const name = {
          text: 'Name',
          value: 'name',
          class: 'text-table-header'
        }
        filteredOptions.map(item => {
          item['class'] = 'text-table-header'
        })
        return [checkbox, name, ...filteredOptions]
      }
    },
    containFilter: {
      get() {
        let data = false
        for (const key in this.filters) {
          const value = this.filters[key]
          if (value) {
            data = true
          }
        }
        return data
      }
    },
    isMobileScreen() {
      return this.$vuetify.breakpoint.xs
    }
  },
  watch: {
    pageSize() {
      this.fetchCustomers(1)
    },
    filters: {
      deep: true,
      handler() {
        this.selectedCustomers = []
        this.fetchCustomers(1)
      }
    }
  },
  created() {
    this.$store.commit('customers/resetFilters')
  },
  methods: {
    ...mapActions(['showMessage']),
    addFilter() {
      this.showFilterDrawer = true
    },
    getCustomers(page, pageSize, query, filters) {
      const params = {
        page_size: pageSize,
        page,
        search: query || ''
      }
      for (const key in filters) {
        const value = filters[key]
        if (value) {
          params[key] = value
        }
      }
      return this.$axios.get(`/connect/${this.company.slug}/customers`, { params })
    },
    fetchCustomers(page, query) {
      this.isLoading = true
      this.getCustomers(page, this.pageSize, query, this.filters)
      .then(resp => {
        const data = resp.data
        this.customers = data.results
        this.customers.map(item => {
          item.checked = false
          if (this.previousCustomers) {
            if (this.previousCustomers.includes(item.id)) {
              item.checked = true
            }
          }
        })
        this.totalCount = data.count
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    pageChanged(num) {
      this.fetchCustomers(num)
    },
    queryChanged: debounce(function (query) {
      this.fetchCustomers(1, query)
    }, 750),
    successDeleteCustomer() {
      this.reset()
    },
    onChecked() {
      this.selectedCustomers = this.customers.filter(item => item.checked === true)
      this.customers = [...this.customers]
      this.checkAll = false
      this.emitSelectedCustomers()
    },
    onCheckedAll() {
      const clone = [...this.customers]
      clone.map(item => item.checked = this.checkAll)
      this.customers = [...clone]
      this.selectedCustomers = this.customers.filter(item => item.checked === true)
      this.emitSelectedCustomers()
    },
    clearSelection() {
      this.checkAll = false
      this.onCheckedAll()
    },
    onDelete() {
      this.showDeleteDialog = true
    },
    onAddSegment() {
      this.showAddDialog = true
    },
    successAddCustomer() {
      this.reset()
    },
    reset() {
      this.checkAll = false
      this.selectedCustomers = []
      this.fetchCustomers(1)
    },
    onContinue() {
      this.$emit('onContinue', this.selectedCustomers)
    },
    emitSelectedCustomers() {
      this.$emit('onSelectedCustomers', this.selectedCustomers)
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>